import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const FailedIconCD = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)
  if (!state.locationDesignConfig) return null

  return (
    <svg
      {...props}
      viewBox="0 0 699 292"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_9)">
        <path
          opacity="0.25"
          d="M37.398 58.4896C74.7196 -22.7413 451.533 3.47874 457.259 6.06621C507.062 16.494 619.964 58.7776 673.144 144.494C739.618 251.64 669.126 255.579 561.577 284.308C454.026 313.037 100.316 254.835 38.1836 215.933C-23.9488 177.03 0.0760393 139.721 37.398 58.4896Z"
          fill="url(#paint0_linear_1_9)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M347 270C419.901 270 479 210.901 479 138C479 65.098 419.901 6 347 6C274.098 6 215 65.098 215 138C215 210.901 274.098 270 347 270ZM347 265.056C417.171 265.056 474.056 208.171 474.056 138C474.056 67.8282 417.171 10.944 347 10.944C276.829 10.944 219.944 67.8282 219.944 138C219.944 208.171 276.829 265.056 347 265.056Z"
          fill={state.locationDesignConfig.baseColors.primary}
        />
        <path
          d="M346.107 167.472L345.159 84.9501V71H352.424L352.266 84.9501L351.319 167.472H346.107ZM348.792 205C347.002 205 345.422 204.214 344.053 202.642C342.684 201.07 342 198.909 342 196.158C342 193.277 342.684 191.05 344.053 189.478C345.422 187.906 347.002 187.12 348.792 187.12C350.582 187.12 352.108 187.906 353.372 189.478C354.741 191.05 355.425 193.277 355.425 196.158C355.425 198.909 354.741 201.07 353.372 202.642C352.108 204.214 350.582 205 348.792 205Z"
          fill={state.locationDesignConfig.baseColors.primary}
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1_9"
          x1="7.83514"
          y1="113.039"
          x2="673.175"
          y2="87.5319"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={state.locationDesignConfig.baseColors.secondary} />
          <stop
            offset="1"
            stopColor={state.locationDesignConfig.baseColors.primary}
            stopOpacity="0"
          />
        </linearGradient>
        <clipPath id="clip0_1_9">
          <rect width="699" height="292" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default FailedIconCD
